import { colorPrimitives } from '../primitives/colors';
import { colorScale } from './color-scale';

/** Chakra color tokens — derived from {@link colorPrimitives}. */
export const colors = {
  transparent: { value: 'transparent' },
  current: { value: 'currentColor' },
  black: { value: colorPrimitives.neutral[500] },
  white: { value: colorPrimitives.neutral[0] },
  neutral: colorScale(colorPrimitives.neutral),
  brand: colorScale(colorPrimitives.primary),
  neonGreen: colorScale(colorPrimitives.accent),
  purple: colorScale(colorPrimitives.secondary),
  secondary: colorScale(colorPrimitives.secondary),
  red: colorScale(colorPrimitives.red),
  orange: colorScale(colorPrimitives.orange),
  green: colorScale(colorPrimitives.green),
  blue: colorScale(colorPrimitives.blue),
};
